import type { SpeechToTextTokenPort } from '@/shared-responder-v2-core';
import { SPEECH_TO_TEXT_TOKEN_REQUEST } from '@/shared-survey';

type SpeechToTextTokenRequest = typeof SPEECH_TO_TEXT_TOKEN_REQUEST;

interface IssuedSpeechToTextToken {
  readonly token: string;
  readonly expiresAt: string;
}

export function createSpeechToTextTokenPort(
  issueToken: (
    request: SpeechToTextTokenRequest
  ) => Promise<IssuedSpeechToTextToken | null | undefined>
): SpeechToTextTokenPort {
  return {
    isAvailable: true,
    requestToken: async () => {
      const issued = await issueToken(SPEECH_TO_TEXT_TOKEN_REQUEST);

      if (!issued?.token) {
        return null;
      }

      return { token: issued.token, expiresAt: issued.expiresAt };
    },
  };
}
